<template>
  <div>
    <VueApexCharts
      type="pie"
      :options="pieChart.options"
      :series="pieChart.series"
    ></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pieChart: {
        options: {
          chart: {
            height: 365,
            type: "pie",
          },
          dataLabels: {
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              opacity: 0.45,
            },
          },
          colors: ["#ffc0cb", "#3b82f6"],
          labels: [
            "Pecahan Ahli Majlis Mengikut Jantina Wanita",
            "Pecahan Ahli Majlis Mengikut Jantina Lelaki",
          ],
          // title: {
          //   text: "HeatMap Chart (Single color)",
          // },
        },
        series: [325, 1442],
      },
      radialBarChart: {
        options: {
          chart: {
            height: 350,
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: "30%",
                background: "transparent",
                image: undefined,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          colors: ["#1ab7ea", "#0084ff", "#39539E", "#0077B5"],
          labels: [
            "Pecahan Ahli Majlis Mengikut Jantina Wanita",
            "Pecahan Ahli Majlis Mengikut Jantina Lelaki",
          ],
          legend: {
            show: true,
            floating: true,
            position: "left",
            offsetX: 140,
            offsetY: 15,
            labels: {
              useSeriesColors: true,
            },
            markers: {
              size: 0,
            },
            formatter: function (seriesName, opts) {
              return (
                seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
              );
            },
            itemMargin: {
              horizontal: 1,
            },
          },
        },
        series: [325, 1442],
      },
    };
  },
  components: {
    VueApexCharts,
  },
};
</script>
